var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBalancerPool06430732(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7855_343371)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C24.8352 0 32 7.1648 32 16C32 24.8352 24.8352 32 16 32C7.1648 32 0 24.8352 0 16C0 7.1648 7.1648 0 16 0Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.24 22.6879C11.1232 22.6879 6.97601 21.2095 6.97601 19.2287C6.97601 18.1951 8.10561 17.2639 9.91361 16.6079C11.3248 17.5135 13.6928 17.9775 16.3776 17.9775C18.9984 17.9775 21.3152 17.4111 22.7392 16.5439C24.4448 17.1935 25.504 18.0991 25.504 19.0975C25.504 21.0815 21.3568 22.6879 16.24 22.6879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2944 17.5328C12.416 17.5328 9.27039 16.3168 9.27039 14.816C9.27039 13.984 10.24 13.2384 11.76 12.7424C12.8448 13.3088 14.4704 13.6704 16.2944 13.6704C18.1184 13.6704 19.744 13.3088 20.8288 12.7424C22.352 13.2416 23.3184 13.984 23.3184 14.816C23.3216 16.3168 20.176 17.5328 16.2944 17.5328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2688 13.2193C13.2704 13.2193 10.8384 12.2145 10.8384 10.9793C10.8384 9.74406 13.2704 8.73926 16.2688 8.73926C19.2672 8.73926 21.6992 9.74406 21.6992 10.9793C21.6992 12.2145 19.2672 13.2193 16.2688 13.2193Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7855_343371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalancerPool06430732);
export default __webpack_public_path__ + "static/media/balancer-pool.06430732.c42bfc7da1eb31de6ae1e800f6703bfc.svg";
export { ForwardRef as ReactComponent };